import React from "react";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import _ from "underscore";

import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Container from "react-bootstrap/esm/Container";
import Tabs from "react-bootstrap/esm/Tabs";
import Tab from "react-bootstrap/esm/Tab";
import Image from "react-bootstrap/Image";
import config from "../../../config";
import Slider from "react-slick";
import {deleteFavorite, saveFavorite} from "../../actionCreators/favoritesAC";
import {carouselSettings, countNonEmptyCollections, getCookie, getImageSize} from "../../common/utils";
import {renderAuthPopup} from "../../actionCreators/pdpAC";
import ProductVariation from "../../PDP/Columns/ProductVariation";
import {ModelProductList} from "../../common/ModelProductList";

function createCarouselObject(shopify_favorites_list, recently_viewed_products, for_you_products){
    return {
        "New For You": {
            collection: "New For You",
            products: for_you_products && ModelProductList(for_you_products.items),
            total_products: for_you_products && for_you_products.items.length,
            collection_url: `${config.host_rebag_shop}/collections/new-arrivals/?${for_you_products && for_you_products.bc_url}`
        },
        "Recently Viewed": {
            collection: "Recently Viewed",
            products: recently_viewed_products,
            total_products: recently_viewed_products.length,
            collection_url: `${config.host_rebag_shop}/collections/new-arrivals?pf_st_availability_hidden=true`
        },
        "Your Favorites": {
            collection: "Your Favorites",
            products: shopify_favorites_list,
            total_products: shopify_favorites_list.length,
            collection_url: `${config.host_rebag}/my-account/favorites`
        }
    };
}

class PersonalizedCarouselModule extends React.Component {
    constructor() {
        super();
    }

    render() {
        const slider_settings = {
            className: "products-carousel__cards rebag-carousel__cards",
            dotsClass: "slick-dots--custom",
        }
        const sliderSettings = carouselSettings(slider_settings);

        const { shopify_favorites_list, recently_viewed_products, for_you_products} = this.props;
        const personalized_collections = createCarouselObject(shopify_favorites_list, recently_viewed_products, for_you_products);
        const personalized_collections_keys = Object.keys(personalized_collections);
        const item_limit = window.innerWidth <= 768 ? 4 : 14;
        const collections_with_products = countNonEmptyCollections(personalized_collections);
        const is_b2b = getCookie('is_b2b');
        const is_wholesale_active = getCookie("is_wholesale_active");

        if(personalized_collections_keys.length <= 0){
            return (
                <div/>
            )
        }

        return (
            <div className="rebag-carousel curated-collections-carousel">
                <Row>
                    <Col>
                        <h2 className="rebag-carousel__title">Your Collections</h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Tabs
                            id="personalized-collections"
                            className={`rebag-carousel__tab-container ${(collections_with_products < 3) ? "rebag-carousel__tab-container--center" : ""}`}
                        >
                            {_.map(personalized_collections, (personalized_collection, personalized_collection_filter) => {
                                if (_.isEmpty(personalized_collection.products)) {
                                    return null;
                                }
                                const collection_name = personalized_collection.collection;
                                const shopify_url = personalized_collection.collection_url;
                                const tab_title = <span>
                                    <span className="rebag-carousel__tab--img-container">
                                        <Image
                                            alt={collection_name}
                                            title={collection_name}
                                            className="rebag-carousel__tab--img"
                                            src={getImageSize(personalized_collection.products[0].image, 96)}
                                            width="48"
                                            height="48"
                                        />
                                    </span>
                                    <div className="rebag-carousel__tab--title">
                                        {collection_name}
                                    </div>
                                    <div className="rebag-carousel__tab--border"/>
                                </span>;
                                return (
                                    <Tab
                                        key={personalized_collection_filter}
                                        eventKey={personalized_collection_filter}
                                        title={tab_title}
                                        unmountOnExit={true}
                                        tabClassName="rebag-carousel__tab"
                                    >
                                        <div className="products-carousel__cards-container">
                                            <Container className="position-relative">
                                                <Slider {...sliderSettings}>
                                                    {_.last(_.map(personalized_collection.products, (product) => {
                                                        return (
                                                            <ProductVariation
                                                                key={`${personalized_collection}-${product.id}`}
                                                                product_variation={product}
                                                                is_b2b={is_b2b}
                                                                is_wholesale_active={is_wholesale_active}
                                                            />
                                                        )
                                                    }), item_limit)}
                                                    {personalized_collection.total_products > item_limit && collection_name === "Your Favorites" &&
                                                    <div className="products-carousel__card products-carousel__card--more-items">
                                                        <a
                                                            href={shopify_url}
                                                            className="products-carousel__card-link-container"
                                                        >
                                                            <Image
                                                                alt="More Matches Available"
                                                                title="More Matches Available"
                                                                className="saved-search__more-items-icon"
                                                                src={`${config.MEDIA_URL}/img/shopping-bag-thin.svg`}
                                                            />
                                                            {collection_name !== "Your Favorites" &&
                                                            <div className="saved-search__more-items-title">
                                                                More Matches Available
                                                            </div>
                                                            }
                                                            <div className="saved-search__more-items-link">
                                                                View All
                                                            </div>
                                                        </a>
                                                    </div>
                                                    }
                                                </Slider>
                                                {collection_name === "Your Favorites" &&
                                                <a
                                                    href={shopify_url}
                                                    className='rebag-carousel__see-all-cta'
                                                >
                                                    See All <i/>
                                                </a>
                                                }
                                            </Container>
                                        </div>
                                    </Tab>
                                )
                            })}
                        </Tabs>
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        renderAuthPopup,
        saveFavorite,
        deleteFavorite
    }, dispatch)
}

export default connect(null, mapDispatchToProps)(PersonalizedCarouselModule);